export default "__VITE_ASSET__9FXRGDHE__"